// extracted by mini-css-extract-plugin
module.exports = {"TableCell":"TableCell_TableCell__1oK7B"};